import React, { memo } from 'react'
import { IconButton } from '@mui/material'
import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons'

import FaIcon from '../faIcon/FaIcon'
import CustomTooltip from '../customTooltip/CustomTooltip'

const PopoverHelpText = ({ label, size = 16 }) => {
  return (
    <CustomTooltip label={label}>
      <IconButton
        sx={{
          p: 0.375,
          fontSize: 'inherit',
          '&:hover': { backgroundColor: 'transparent' }
        }}
        disableRipple
      >
        <FaIcon icon={faCircleQuestion} width={size} />
      </IconButton>
    </CustomTooltip>
  )
}

export default memo(PopoverHelpText)
